import React from 'react';
import { useIntl } from 'react-intl';
import { Form, Row, Col, Input, FormInstance, Switch } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { CreateAreaRequest } from '@/core/domain/operational/Areas/Areas.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

type Props = {
  isEdit?: boolean;
  form: FormInstance<CreateAreaRequest>;
};

const SubareaForm: React.FC<Props> = ({ form, isEdit = false }) => {
  const intl = useIntl();

  const defaultEmptyFieldError = {
    required: true,
    message: intl.formatMessage({
      id: 'commons.form.errors.requiredField',
    }),
  };

  return (
    <Form form={form}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FloatingFormItem
            name="name"
            rules={[defaultEmptyFieldError]}
            label={intl.formatMessage({
              id: 'areas.subareas.description',
            })}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        {isEdit && (
          <Col span={24}>
            <FloatingFormItem name="active" noStyle valuePropName="checked">
              <Switch
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
                disabled={!hasPermissions([Authorities.REGISTER_SUBAREA_EDIT])}
              />
            </FloatingFormItem>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default SubareaForm;
